<div id="phenology">
  @if (selectedPlantation?.activeRotationId) {
    <div class="row">
      <div class="col-12 col-md-4">
        <p class="title">
          <span>
            {{ 'doktar_app.services.crop_monitoring.phenology.phenological_stages.title' | translate }}
          </span>
        </p>
        <app-phenological-stages [selectedPlantation]="selectedPlantation" />
      </div>
      <div class="col-12 col-md-8">
        <div class="photos-panel" style="padding-left: 25px; border-left: 2px solid #e6e6e6">
          <app-phenological-images [selectedPlantation]="selectedPlantation" />
        </div>
      </div>
    </div>
  } @else {
    <p class="title">
      <span>
        {{ 'doktar_app.services.crop_monitoring.phenology.crop_phenology' | translate }}
      </span>
    </p>
    <div class="no-rotation">
      <i class="ph ph-arrows-counter-clockwise icon"></i>
      <p class="title">{{ 'doktar_app.services.agroclimate.no_active_rotation_title' | translate }}</p>
      <p class="content">
        {{ 'doktar_app.services.agroclimate.no_active_rotation_description' | translate }}
      </p>
      <dk-button
        [label]="'doktar_app.services.agroclimate.go_to_plantation_details_button' | translate"
        [routerLink]="'/lands/' + selectedLand?.id + '/' + selectedPlantation?.id" />
    </div>
  }
</div>
